/* eslint-disable no-param-reassign */

import React, { FunctionComponent, useMemo } from 'react'

import { capitalize, snakeCaseTransform } from 'Helpers/layoutHelpers'
import { ReviewStatus } from 'Types/index'

import { TrackDetailsProps } from './props'
import {
  TrackDetailsContainer,
  TrackDetailsTitle,
  TrackDetailsRow,
  TrackDetailsRowLabel,
  TrackDetailsRowInfo,
} from './styles'

export const TrackDetails: FunctionComponent<TrackDetailsProps> = ({
  reviewDetails,
}) => {
  const memoGenres = useMemo(
    () =>
      reviewDetails?.track?.genres?.reduce((acc, el, id) => {
        acc += capitalize(el.name)
        if (id !== reviewDetails?.track?.genres?.length - 1) {
          acc += ', '
        }
        return acc
      }, ''),
    [reviewDetails]
  )

  const memoLanguages = useMemo(
    () =>
      reviewDetails?.track?.languages?.reduce((acc, el, id) => {
        acc += capitalize(el.name)
        if (id !== reviewDetails?.track?.languages?.length - 1) {
          acc += ', '
        }
        return acc
      }, ''),
    [reviewDetails]
  )

  return (
    <TrackDetailsContainer>
      <TrackDetailsTitle>Track details</TrackDetailsTitle>
      <TrackDetailsRow>
        <TrackDetailsRowLabel>Genres:</TrackDetailsRowLabel>
        <TrackDetailsRowInfo>{memoGenres}</TrackDetailsRowInfo>
      </TrackDetailsRow>
      <TrackDetailsRow>
        <TrackDetailsRowLabel>Vocal:</TrackDetailsRowLabel>
        <TrackDetailsRowInfo>{memoLanguages}</TrackDetailsRowInfo>
      </TrackDetailsRow>
      <TrackDetailsRow>
        <TrackDetailsRowLabel>Status:</TrackDetailsRowLabel>
        <TrackDetailsRowInfo
          orange={reviewDetails?.review_status === ReviewStatus.awaiting_review}
        >
          {// @ts-ignore
          capitalize(snakeCaseTransform(reviewDetails?.review_status))}
        </TrackDetailsRowInfo>
      </TrackDetailsRow>
      <TrackDetailsRow>
        <TrackDetailsRowLabel>Reward:</TrackDetailsRowLabel>
        <TrackDetailsRowInfo>{`$${reviewDetails?.potential_reward} (Rank ${reviewDetails?.rank})`}</TrackDetailsRowInfo>
      </TrackDetailsRow>
    </TrackDetailsContainer>
  )
}
